<template>

  <svg
    t="1629550762435"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3928"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="64"
    height="64"
  ><path d="M512 128l448 768H64L512 128z m0 126.912L175.36 832h673.216L512 254.912zM544 704v64h-64v-64h64z m0-256v192h-64V448h64z" p-id="3929" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconWarning',
} as DefineComponent
</script>